import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Task } from "../../shared/task";

@Component({
  selector: "om-task-options",
  templateUrl: "./task-options.component.html",
})
export class TaskOptionsComponent implements OnInit {
  @Input() task: Task;
  @Output() completed = new EventEmitter();
  @Output() declined = new EventEmitter();
  @Output() secondButtonCompleted = new EventEmitter();

  ngOnInit() {}

  onComplete() {
    this.completed.emit();
  }

  onSecondButtonComplete() {
    this.secondButtonCompleted.emit();
  }

  onDecline() {
    this.declined.emit();
  }

  get completable() {
    return this.task.isCompletable;
  }

  get hasSecondComplete() {
    return this.task.type == "consult_order";
  }

  get completeButtonText() {
    switch (this.task.type) {
      case "vaccine_order":
        return "I've Received The Vaccine";
      case "consult_order":
        return "I Saw This Specialist";
      default:
        return "I've Already Done This";
    }
  }

  get declineButtonText() {
    switch (this.task.type) {
      case "vaccine_order":
        return "Decline Vaccine";
      case "consult_order":
        return "I No Longer Need A Visit";
      default:
        return "Decline";
    }
  }

  get secondCompleteButtonText() {
    return "I Went Elsewhere";
  }
}
